import { useBlocker } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from './Modal.tsx';

/**
 * Formulário em página (fora de janela): sair com algo alterado e não salvo pede a mesma
 * confirmação de descarte das janelas (guia, "Ficha em página"). Depois de salvar, chame
 * `allowLeave()` antes de navegar para a ficha nova.
 */
export function useLeaveGuard(dirty: boolean) {
  const { t } = useTranslation();
  const dirtyRef = useRef(dirty);
  useEffect(() => {
    dirtyRef.current = dirty;
  }, [dirty]);
  const skip = useRef(false);
  const blocked = () => dirtyRef.current && !skip.current;
  const blocker = useBlocker({
    shouldBlockFn: blocked,
    enableBeforeUnload: blocked,
    withResolver: true,
  });
  return {
    allowLeave: () => {
      skip.current = true;
    },
    dialog: (
      <ConfirmDialog
        open={blocker.status === 'blocked'}
        title={t('modal.discardTitle')}
        description={t('modal.discardText')}
        confirmLabel={t('modal.discard')}
        cancelLabel={t('modal.keepEditing')}
        tone="danger"
        onConfirm={() => blocker.proceed?.()}
        onCancel={() => blocker.reset?.()}
      />
    ),
  };
}
